var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"playhub-account"},[_c('playhub-account'),_c('illustration-mosaic')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }